(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["skin-care-tool-results"]) return;
  try {
    
  if (window.Shopify.designMode) {
    var section = document.querySelector('#shopify-section-skin-care-tool-results .skn-Results');

    if (section) {
      section.classList.remove('skn-Results-hidden');
    }
  }

  } catch(e) { console.error(e); }
})();
      })();
